<template>
  <v-container fluid class="material-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-material`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-label</v-icon>
            Material
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>

          <v-tab-item
            :value="'tab-material'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">Edit Material</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeMaterial($event, 'materialnum')"
                        v-bind:value="edit_material.materialnum"
                        placeholder="Material Num"
                        persistent-hint
                        single-line hint="Enter the material num">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeMaterial($event, 'materialname')"
                        v-bind:value="edit_material.materialname"
                        placeholder="Material Name"
                        persistent-hint
                        single-line hint="Enter the material name">
                      </v-text-field>

                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeMaterial($event, 'materialinfo')"
                        v-bind:value="edit_material.materialinfo"
                        placeholder="Info"
                        persistent-hint
                        single-line hint="Enter the material info">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items=materialtypes
                        :value="edit_material.materialtype"
                        outlined
                        dense
                        v-on:change="onChangeMaterial($event, 'materialtype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the material type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="brands.map(x => {
                            return {text: x.brandname, value: x._id};
                          })"
                        :value="edit_material.brandid"
                        outlined
                        dense
                        v-on:change="onChangeMaterial($event, 'brandid')"
                        placeholder="Brand"
                        persistent-hint
                        single-line hint="Please choose the brand">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Active', 'Inactive']"
                        :value="edit_material.materialstatus"
                        outlined
                        dense
                        v-on:change="onChangeMaterial($event, 'materialstatus')"
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the status">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeMaterial($event, 'materialsize')"
                        v-bind:value="edit_material.materialsize"
                        placeholder="Material Size"
                        persistent-hint
                        single-line hint="Enter the material size">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="onChangeMaterial($event, 'materialweight')"
                        v-bind:value="edit_material.materialweight"
                        placeholder="Material Weight"
                        persistent-hint
                        single-line hint="Enter the material weight (kg)">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="onChangeMaterial($event, 'materialconvert')"
                        v-bind:value="edit_material.materialconvert"
                        placeholder="Unit Quantity"
                        persistent-hint
                        single-line hint="Enter the material unit quantity (pcs)">
                      </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="9" sm="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/material/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editMaterial()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/material/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Material', ['materials', 'isReceiving']),
  },
  data () {
    return {
      imageurl: undefined,
      filename: null,
      error: undefined,
      isErrorTag: false,
      errorindex: undefined,
      
      edit_material: {},
      edit_photo: {},
      change_material: {},
      initvalue: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      materialtypes: ['Material', 'Overhead', 'Other Material'],
    }
  },
  methods: {
    ...mapActions('Material', ['getMaterialsRequest', 'updateMaterialRequest', 'updateMaterialImageRequest']),
    ...mapActions('Brand', ['getBrandsRequest']),
    async editMaterial() {
      this.change_material._id = this.initvalue._id;
      await this.updateMaterialRequest(this.change_material);
      router.push('/material/list');
    },
    async editPhoto() {
      this.edit_photo._id = this.initvalue._id;
      await this.updateMaterialImageRequest(this.edit_photo);
      router.push('/material/list');
    },
    onChangeMaterial(value, field){
      this.change_material[field] = value;
    },
    onFileChange(file) {
      if (!file) {return;}
      this.edit_photo.imagefile = file;
      this.edit_photo.imagename = file.name;
      const reader = new FileReader();
      reader.onload = e => this.imageurl = e.target.result;
      reader.readAsDataURL(file);
    },
    onDetailFileChange(file) {
      if (!file) {return;}
      this.detail.detailimage = file;
      this.detail.imagename = file.name;
    },
  },
  created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'MaterialList' });
    this.imageurl = this.initvalue.materialimage;
    this.edit_material = Object.assign({}, this.initvalue);
    this.files = this.initvalue.files;
    if(this.brands.length==0) this.getBrandsRequest();
    if(this.materials.length==0) this.getMaterialsRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
